export default __webpack_public_path__ + "static/media/controlShareAndroid24.29c2bb34.svg";